import $ from 'jquery';
import { request } from './utils';
import * as config from '../config/config';

export const setLanguage = url => request({
  url,
  method: 'get',
});

export default {};

export const getVisitorType = () => request({
  url: config.API.getVisitorType,
  method: 'get',
});

export const getEffectiveAreaList = typeId => request({
  url: config.API.getEffectiveAreaList(typeId),
  method: 'get',
});

export const getELLessonCategoryList = () => request({
  url: config.API.getELLessonCategoryList,
  method: 'get',
});

export const getELLessonList = (areaId, typeId) => request({
  url: config.API.getELLessonList(areaId, typeId),
  method: 'get',
});

export const getKOByKeywords = (pageIndex, pageCount, queryModel) => request({
  url: config.API.getKOByKeywords(pageIndex, pageCount, queryModel),
  method: 'get',
});

export const getUserInfo = () => request({
  url: config.API.getUserInfo,
  method: 'get',
});

export const getMaterialOptions = (areaId, typeId) => request({
  url: config.API.getMaterialOptions(areaId, typeId),
  method: 'get',
});

export const InsertOrUpdate = insertOrUpdateInviteModel => request({
  url: config.API.InsertOrUpdate,
  method: 'post',
  data: insertOrUpdateInviteModel,
});

export const getOverviewInfo = InvitationId => request({
  url: config.API.getOverviewInfo(InvitationId),
  method: 'get',
});

export const getInvitationInfo = InvitationId => request({
  url: config.API.getInvitationInfo(InvitationId),
  method: 'get',
});

export const getInvitationSchedule = InvitationId => request({
  url: config.API.getInvitationSchedule(InvitationId),
  method: 'get',
});

export const materialReview = dataObj => request({
  url: config.API.materialReview,
  method: 'post',
  data: dataObj,
});

export const getRejectReasons = InvitationId => request({
  url: config.API.getRejectReasons(InvitationId),
  method: 'get',
});

export const getInviteListByCheck = (pageIndex, pageCount, keyWorks, ticketUserRole, checkStatus) => request({
  url: config.API.getInviteListByCheck(pageIndex, pageCount, keyWorks, ticketUserRole, checkStatus),
  method: 'get',
});

export const getInviteListByToday = (pageIndex, pageCount, keyWorks, visitStatus, ticketUserRole) => request({
  url: config.API.getInviteListByToday(pageIndex, pageCount, keyWorks, visitStatus, ticketUserRole),
  method: 'get',
});

export const checkPassOrReject = dataObj => request({
  url: config.API.checkPassOrReject,
  method: 'post',
  data: dataObj,
});

export const getInviteListAll = (pageIndex, pageCount, keyWorks, visitStatus, ticketUserRole) => request({
  url: config.API.getInviteListAll(pageIndex, pageCount, keyWorks, visitStatus, ticketUserRole),
  method: 'get',
});

export const getInviteListCC = (pageIndex, pageCount, keyWorks, visitStatus) => request({
  url: config.API.getInviteListCC(pageIndex, pageCount, keyWorks, visitStatus),
  method: 'get',
});

export const deleteInvitation = ticketId => request({
  url: config.API.deleteInvitation(ticketId),
  method: 'get',
});

export const getDeliveryTrackingAdminList = ticketId => request({
  url: config.API.getDeliveryTrackingAdminList(ticketId),
  method: 'get',
});

export const getInviteListWarehouse = (pageIndex, pageCount, keyWorks, targetDate, warehouseStatus) => request({
  url: config.API.getInviteListWarehouse(pageIndex, pageCount, keyWorks, targetDate, warehouseStatus),
  method: 'get',
});

export const sendRemind = ApproverId => request({
  url: config.API.sendRemind(ApproverId),
  method: 'post',
});

export const deleteGoodsListByIdAndTicketId = (GoodsListId, InvitationId) => request({
  url: config.API.deleteGoodsListByIdAndTicketId(GoodsListId, InvitationId),
  method: 'get',
});

export const insertOrUpdateDeliveryTrackingGoodsList = dataObj => request({
  url: config.API.insertOrUpdateDeliveryTrackingGoodsList,
  method: 'post',
  data: dataObj,
});

export const goodsListCheckPassOrReject = dataObj => request({
  url: config.API.goodsListCheckPassOrReject,
  method: 'post',
  data: dataObj,
});

export const getAgent = () => request({
  url: config.API.getAgent(),
  method: 'get',
});

export const uploadPicture = (isDocPhoto, fileData) => request({
  url: config.API.uploadPicture(isDocPhoto),
  method: 'post',
  data: fileData,
});

export const uploadAnnex = fileData => request({
  url: config.API.uploadAnnex,
  method: 'post',
  data: fileData,
});

export const loadHistroyMaterialAnswers = (phone, email) => request({
  url: config.API.loadHistroyMaterialAnswers(phone, email),
  method: 'get',
});

export const loadHistroyCompanyMaterialAnswers = keywords => request({
  url: config.API.loadHistroyCompanyMaterialAnswers(keywords),
  method: 'get',
});

export const submitAgent = dataObj => request({
  url: config.API.submitAgent,
  method: 'post',
  data: dataObj,
});

export const cancelAgent = () => request({
  url: config.API.cancelAgent(),
  method: 'get',
});

export const getUnReadList = () => request({
  url: config.API.getUnReadList(),
  method: 'get',
});

export const setRead = () => request({
  url: config.API.setRead(),
  method: 'get',
});

export const setSingleRead = messageId => request({
  url: config.API.setSingleRead(messageId),
  method: 'get',
});

export const getInvitationInfoForEdit = ticketId => request({
  url: config.API.getInvitationInfoForEdit(ticketId),
  method: 'get',
});

export const sendVerificationCodeExternal = account => request({
  url: config.API.sendVerificationCodeExternal,
  method: 'post',
  data: {
    account,
  },
});

export const getInvitationOverview = (invitationId, isNeedEffective) => request({
  url: config.API.getInvitationOverview(invitationId, isNeedEffective),
  method: 'get',
});

export const getInvitationInfoExternal = invitationId => request({
  url: config.API.getInvitationInfoExternal(invitationId),
  method: 'get',
});

export const getExternalInviteList = (pageIndex, pageCount, keyWorks, visitStatus, ticketUserRole) => request({
  url: config.API.getExternalInviteList(pageIndex, pageCount, keyWorks, visitStatus, ticketUserRole),
  method: 'get',
});

export const clickToForward = dataObj => request({
  url: config.API.clickToForward,
  method: 'post',
  data: dataObj,
});

export const getExternalLessonCategory = invitationId => request({
  url: config.API.getExternalLessonCategory(invitationId),
  method: 'get',
});

export const removeMaterial = VisitorId => request({
  url: config.API.removeMaterial(VisitorId),
  method: 'get',
});

export const removeVisitor = VisitorId => request({
  url: config.API.removeVisitor(VisitorId),
  method: 'get',
});

export const getExternalMaterialOptions = (areaId, typeId) => request({
  url: config.API.getExternalMaterialOptions(areaId, typeId),
  method: 'get',
});

export const uploadPictureExternal = (isDocPhoto, fileData) => request({
  url: config.API.uploadPictureExternal(isDocPhoto),
  method: 'post',
  data: fileData,
});

export const uploadAnnexExternal = fileData => request({
  url: config.API.uploadAnnexExternal,
  method: 'post',
  data: fileData,
});

export const getExternalVisitorInfo = visitorid => request({
  url: config.API.getExternalVisitorInfo(visitorid),
  method: 'get',
});

export const insertVisitors = insertVisitorsModel => request({
  url: config.API.insertVisitors,
  method: 'post',
  data: insertVisitorsModel,
});

export const loadHistroyExternalMaterialAnswers = (phone, email) => request({
  url: config.API.loadHistroyExternalMaterialAnswers(phone, email),
  method: 'get',
});

export const getCurrentAccount = () => request({
  url: config.API.getCurrentAccount,
  method: 'get',
});

export const agreeVisitorNotice = InvitationId => request({
  url: config.API.agreeVisitorNotice(InvitationId),
  method: 'get',
});

export const getPrivacyPolicy = () => request({
  url: config.API.getPrivacyPolicy,
  method: 'get',
});


export const editVisitorMaterial = Data => request({
  url: config.API.editVisitorMaterial,
  method: 'post',
  data: Data,
});

export const loadHistroyExternalCompanyAnswers = keywords => request({
  url: config.API.loadHistroyExternalCompanyAnswers(keywords),
  method: 'get',
});

export const securityGetOverviewInfo = InvitationId => request({
  url: config.API.securityGetOverviewInfo(InvitationId),
  method: 'get',
});

export const securityGetInvitationSchedule = InvitationId => request({
  url: config.API.securityGetInvitationSchedule(InvitationId),
  method: 'get',
});

export const getVisitSituation = () => request({
  url: config.API.getVisitSituation(),
  method: 'get',
});

export const getSecurityUserInfo = () => request({
  url: config.API.getSecurityUserInfo,
  method: 'get',
});

export const getSecurityGuardPostList = () => request({
  url: config.API.getSecurityGuardPostList,
  method: 'get',
});

export const setPosition = id => request({
  url: config.API.setPosition(id),
  method: 'get',
});

export const getSecurityGuardPostPeopleCount = () => request({
  url: config.API.getSecurityGuardPostPeopleCount,
  method: 'get',
});

export const sevurityGetInvitationInfo = InvitationId => request({
  url: config.API.sevurityGetInvitationInfo(InvitationId),
  method: 'get',
});

export const securityTodayInvitelist = keyWorks => request({
  url: config.API.securityTodayInvitelist(keyWorks),
  method: 'get',
});

export const securityInsertOrUpdateDeliveryTrackingGoodsList = dataObj => request({
  url: config.API.securityInsertOrUpdateDeliveryTrackingGoodsList,
  method: 'post',
  data: dataObj,
});

export const securityDeleteGoodsListByIdAndTicketId = (GoodsListId, TicketId) => request({
  url: config.API.securityDeleteGoodsListByIdAndTicketId(GoodsListId, TicketId),
  method: 'get',
});

export const SecurityGuardPostId = (InvitationId, SecurityGuardPostId) => request({
  url: config.API.SecurityGuardPostId(InvitationId, SecurityGuardPostId),
  method: 'get',
});

export const agreeToLeave = dataObj => request({
  url: config.API.agreeToLeave,
  method: 'post',
  data: dataObj,
});

export const getSecurityGuardPostButtonList = () => request({
  url: config.API.getSecurityGuardPostButtonList,
  method: 'get',
});

export const faceRecognition = model => request({
  url: config.API.faceRecognition,
  method: 'post',
  data: model,
});

export const checkVisitorHasCard = (cardType, ticketId, visitorId) => request({
  url: config.API.checkVisitorHasCard(cardType, ticketId, visitorId),
  method: 'get',
});

export const checkIn = (ticketId, visitorId, checkInType, qrCode) => request({
  url: config.API.checkIn(ticketId, visitorId, checkInType, qrCode),
  method: 'post',
});

export const getSecurityCardInfo = (cardId, checkcode) => request({
  url: config.API.getSecurityCardInfo(cardId, checkcode),
  method: 'get',
});

export const getNormalCardInfo = (cardId, checkcode) => request({
  url: config.API.getNormalCardInfo(cardId, checkcode),
  method: 'get',
});

export const postCardImageUrl = dataObj => request({
  url: config.API.postCardImageUrl,
  method: 'post',
  data: dataObj,
});

export const uploadPictureByBase64 = model => request({
  url: config.API.uploadPictureByBase64,
  method: 'post',
  data: model,
});

export const uploadPictureByBase64Ex = model => request({
  url: config.API.uploadPictureByBase64Ex,
  method: 'post',
  data: model,
});

export const getSecurityGuardPostNotice = () => request({
  url: config.API.getSecurityGuardPostNotice,
  method: 'get',
});

export const agreeSecurityGuardPostNotice = (agreeVisiotr) => request({
  url: config.API.agreeSecurityGuardPostNotice,
  method: 'post',
  data: agreeVisiotr
});

export const getticketidbyqrcode = (qrcode) => request({
  url: config.API.getticketidbyqrcode+'?qrcode='+ encodeURIComponent(qrcode),
  method: 'get',
});

export const scanQRCodeCheckOut = dataObj => request({
  url: config.API.scanQRCodeCheckOut,
  method: 'post',
  data: dataObj,
});

export const notCardCheckOut = dataObj => request({
  url: config.API.notCardCheckOut,
  method: 'post',
  data: dataObj,
});

export const uploadPictureByBase64Security = model => request({
  url: config.API.uploadPictureByBase64Security,
  method: 'post',
  data: model,
});

export const getExternalLessonList = (invitationId, categoryId) => request({
  url: config.API.getExternalLessonList(invitationId, categoryId),
  method: 'get',
});

export const sendQuickNotification = messageType => request({
  url: config.API.sendQuickNotification(messageType),
  method: 'get',
});

export const getImageUrlByMediaId = mediaId => request({
  url: config.API.getImageUrlByMediaId(mediaId),
  method: 'get',
});

export const getExternalLessonDetail = (invitationId, lessonId) => request({
  url: config.API.getExternalLessonDetail(invitationId, lessonId),
  method: 'get',
});

export const editCarNumber = dataObj => request({
  url: config.API.editCarNumber,
  method: 'post',
  data: dataObj,
});

export const getExamDetail = (ticketId, lessonId, examId) => request({
  url: config.API.getExamDetail(ticketId, lessonId, examId),
  method: 'get',
});

export const submitExam = model => request({
  url: config.API.submitExam,
  method: 'post',
  data: model,
});

export const lessonview = (ticketId, lessonId) => request({
  url: config.API.lessonview(ticketId, lessonId),
  method: 'get',
});

export const getPrintStatus = (cardId, checkCode) => request({
  url: config.API.getPrintStatus(cardId, checkCode),
  method: 'get',
});


export const getInvitationInfoForAgreeToLeave = (InvitationId, SecurityGuardPostId) => request({
  url: config.API.getInvitationInfoForAgreeToLeave(InvitationId, SecurityGuardPostId),
  method: 'get',
});

export const getExternalAccessTokenByKoUser = (InvitationId) => request({
  url: config.API.getExternalAccessTokenByKoUser(InvitationId),
  method: 'get',
});


export const faceImageByBaseEx = model => request({
  url: config.API.faceImageByBaseEx,
  method: 'post',
  data: model,
});

export const faceImageByBase = model => request({
  url: config.API.faceImageByBase,
  method: 'post',
  data: model,
});


export const getExternalHelpContent = () => request({
  url: config.API.getExternalHelpContent,
  method: 'get',
});


export const getBottlerPrimaryVisitors = (TypeId, AreaId) => request({
  url: config.API.getBottlerPrimaryVisitors(TypeId, AreaId),
  method: 'get',
});


export const AgreeVisitorNoticeOffline = (VisitorId) => request({
  url: config.API.AgreeVisitorNoticeOffline(VisitorId),
  method: 'get',
});


export const getQuickNotificationType = () => request({
  url: config.API.getQuickNotificationType,
  method: 'get',
});

// Carrier Visitor
export const getCarrierVisitType = () => request({
  url: config.API.getCarrierVisitType,
  method: 'get',
});

export const getCarrierAreaList = (TypeId) => request({
  url: config.API.getCarrierAreaList(TypeId),
  method: 'get',
});

export const getVisitorBottlers = () => request({
  url: config.API.getVisitorBottlers,
  method: 'get',
});

export const getTimeSchedule = () => request({
  url: config.API.getTimeSchedule,
  method: 'get',
});

export const applyInvitation = model  => request({
  url: config.API.applyInvitation,
  method: 'post',
  data: model
});

export const getTotalCarNumberINfo = ticketId => request({
  url: config.API.getTotalCarNumberINfo(ticketId),
  method: 'post',
});

export const getVisitsecurityTotalCarNumberINfo = ticketId => request({
  url: config.API.getVisitsecurityTotalCarNumberINfo(ticketId),
  method: 'post',
});

export const getChectoutRemarkByDate = (invitationId, securityGuardPostId, targetDate) => request({
  url: config.API.getChectoutRemarkByDate(invitationId, securityGuardPostId, targetDate),
  method: 'get',
});

export const visitorAddNodes = model => request({
  url: config.API.visitorAddNodes,
  method: 'post',
  data: model
});

export const addChectoutRemark = model => request({
  url: config.API.addChectoutRemark,
  method: 'post',
  data: model
});

export const getGuardPostList = invitationId => request({
  url: config.API.getGuardPostList(invitationId),
  method: 'post',
});

export const getCheckInSecurityGuardPostList = invitationId => request({
  url: config.API.getCheckInSecurityGuardPostList(invitationId),
  method: 'post',
});

export const getChectoutRemarkTargetDate = (invitationId, SecurityGuardPostId) => request({
  url: config.API.getChectoutRemarkTargetDate(invitationId, SecurityGuardPostId),
  method: 'get',
});

export const GetCarrierinvitationCheckList = (pageIndex, pageCount, queryModel) => request({
  url: config.API.getCarrierinvitationCheckList(pageIndex, pageCount, queryModel),
  method: 'get',
});

export const GetDockcarinfo = (date) => request({
  url: config.API.getDockcarinfo(date),
  method: 'get',
});

export const getCarrierInvitationDetail = ticketId => request({
  url: config.API.getCarrierInvitationDetail(ticketId),
  method: 'get',
});

export const rejectCarrierTicket = (model) => request({
  url: config.API.rejectCarrierTicket,
  method: 'post',
  data: model
});

export const getDockList = () => request({
  url: config.API.getDockList,
  method: 'get',
});

export const getScheduleList = () => request({
  url: config.API.getScheduleList,
  method: 'get',
});

export const confirmCarrierTicket = (model) => request({
  url: config.API.confirmCarrierTicket,
  method: 'post',
  data: model
});